import WeeklyInsights from "./weekly-insights";

export default WeeklyInsights;